import {
  ITochiGradientMaskMaterial,
  ITochiMaterial,
  ITochiRGBGradientMaskMaterial,
  ITochiTextureMaterial,
} from "@snackpass/snackpass-types";
import GradientMaskMaterial from "./GradientMaskMaterial";
import RGBGradientMaskMaterial from "./RGBGradientMaskMaterial";
import TextureMaterial from "./TextureMaterial";
import TochiMaterial from "./TochiMaterial";

export const getTochiMaterial = (props: ITochiMaterial): TochiMaterial => {
  switch (props.type) {
    case "TEXTURE":
      return new TextureMaterial(props as ITochiTextureMaterial);
    case "GRADIENTMASK":
      return new GradientMaskMaterial(props as ITochiGradientMaskMaterial);
    case "RGBGRADIENTMASK":
      return new RGBGradientMaskMaterial(
        props as ITochiRGBGradientMaskMaterial
      );
    default:
      throw new Error(`Invalid material type`);
  }
};
